// extracted by mini-css-extract-plugin
export var postText = "PriceWithoutVat--postText--kMU9T";
export var tkMyriadProSemiCondensed = "PriceWithoutVat--tk-myriad-pro-semi-condensed--d7bnb";